import {
  PickerOptionLabel,
  PickerOptionLabelProps,
  PickerOptionDescription,
  PickerOptionDescriptionProps,
} from "@/ui";
import { cn } from "@/utils/cn";

export type SearchItemLabelProps = PickerOptionLabelProps;

export const SearchItemLabel = ({ className, ...props }: SearchItemLabelProps) => {
  return (
    <PickerOptionLabel
      className={cn("text-new-primary preset-body-lg min-w-0 truncate", className)}
      {...props}
    />
  );
};

export type SearchItemDescriptionProps = PickerOptionDescriptionProps;

export const SearchItemDescription = ({ className, ...props }: SearchItemDescriptionProps) => {
  return (
    <PickerOptionDescription
      className={cn("preset-body-md text-secondary", className)}
      {...props}
    />
  );
};
